import Layout from "../../components/Layout"
import Stack from "@mui/material/Stack"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { PageTitle } from "../../components/PageTitle"
import { Search } from "@mui/icons-material"
import { Route, Routes, useSearchParams } from "react-router-dom"
import RicercaQuery from "./RicercaQuery"
import RicercaRisultati from "./RicercaRisultati"
import { Info, DocumentScanner } from "@mui/icons-material"
import { useCallback,  useState } from "react"
import { RuleGroupType } from "react-querybuilder"
import { useQsFilters } from "../../hooks/filters"

const initFilters = (params: URLSearchParams) => ({
  query: params.get("query") ?? "",
})

export default function Ricerca() {
  const { filters, setFilters } = useQsFilters(initFilters)

  const initialQuery = filters.query ? JSON.parse(filters.query) : undefined

  const { t, i18n } = useTranslation()
  const lang = i18n.language

  const [query, setQuery] = useState<RuleGroupType>(initialQuery)

  const [searchParams, _setSearchParams] = useSearchParams()

  const setStringQuery = useCallback(
    (query: RuleGroupType) => {
      setQuery(query)
      const stringifiedQuery = JSON.stringify(query)
      setFilters({
        query: stringifiedQuery,
      })
    },
    [setFilters]
  )

  return (
    <Layout padding>
      <Stack sx={{ height: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <PageTitle
            title={t("pages.ricerca")}
            breadcrumbs={[
              {
                label: t("pages.ricerca"),
                iconType: Search,
              },
            ]}
            tabs={[
              {
                label: t("general.query"),
                iconType: Info,
                to: `/${lang}/ricerca?${searchParams.toString()}`,
                matchTo: `/${lang}/ricerca`,
              },
              {
                label: t("general.risultati"),
                iconType: DocumentScanner,
                to: `/${lang}/ricerca/risultati?${searchParams.toString()}`,
                matchTo: `/${lang}/ricerca/risultati`,
              },
            ]}
          />
        </Box>

        <Routes>
          <Route index element={<RicercaQuery query={query} setQuery={setStringQuery} />}></Route>
          <Route path={`risultati`} element={<RicercaRisultati />}></Route>
        </Routes>
      </Stack>
    </Layout>
  )
}
